var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxOutlinedBase = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 20 20"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  x: 0.5,
  y: 0.5,
  rx: 4
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  x: 0.5,
  y: 0.5,
  rx: 4
})));
export { SvgCheckboxOutlinedBase as ReactComponent };
export default __webpack_public_path__ + "assets/images/CheckboxOutlinedBase.b2c3d6a34cd1fed493e3b6b92f2a9918.svg";